import { render, staticRenderFns } from "./ats-detail-table.vue?vue&type=template&id=639b4f8e&scoped=true"
import script from "./ats-detail-table.vue?vue&type=script&lang=ts"
export * from "./ats-detail-table.vue?vue&type=script&lang=ts"
import style0 from "./ats-detail-table.vue?vue&type=style&index=0&id=639b4f8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639b4f8e",
  null
  
)

export default component.exports